import { render, staticRenderFns } from "./PermissionsPage.vue?vue&type=template&id=2e91cc26"
import script from "./PermissionsPage.vue?vue&type=script&lang=js"
export * from "./PermissionsPage.vue?vue&type=script&lang=js"
import style0 from "./PermissionsPage.vue?vue&type=style&index=0&id=2e91cc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports